export { ImageUploadModule } from './lib/image-upload.module';
export { ImageUploadComponent, FileHolder } from './lib/image-upload/image-upload.component';



//////////////////
// WEBPACK FOOTER
// ./~/angular2-image-upload/index.js
// module id = 949
// module chunks = 4